import { render, staticRenderFns } from "./ProductPages.vue?vue&type=template&id=1dad546a&"
import script from "./ProductPages.vue?vue&type=script&lang=js&"
export * from "./ProductPages.vue?vue&type=script&lang=js&"
import style0 from "./ProductPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports